export const versionService = {
    getVersion: (data) => window.axios.post('get-version-list', data),
    addVersion: (data) => window.axios.post('add-version', data),
    deleteVersion: (data) => window.axios.post('delete-version', data),
    getVersionById: (data) => window.axios.post('get-version-by-id', data),
    editVersion: (data) => window.axios.post('edit-version', data),
};